import { Icon, Stack, StackProps } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { DoneIcon, TypographyWithOverflowHint } from '@schooly/style';
import { ReactNode } from 'react';

export type DropdownSelectRowProps = {
  isSelected?: boolean;
  endIcon?: ReactNode;
} & StackProps;

export const DropdownSelectRow = ({
  isSelected,
  endIcon,
  children,
  sx,
  ...stackProps
}: DropdownSelectRowProps) => {
  const icon = endIcon ?? (
    <Icon sx={{ visibility: isSelected ? 'visible' : 'hidden', color: 'primary.main' }}>
      <DoneIcon />
    </Icon>
  );

  return (
    <Stack
      role="menuitem"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      sx={(theme) => ({
        cursor: 'pointer',
        py: '1px',
        px: 0.5,
        borderRadius: theme.spacing(0.5),
        '&:hover': {
          backgroundColor: theme.palette.background.default,
          '& .MuiTypography-root': {
            color: theme.palette.primary.main,
          },
        },
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...stackProps}
    >
      <TypographyWithOverflowHint variant="h3" color={!isSelected ? 'common.grey2' : undefined}>
        {children}
      </TypographyWithOverflowHint>
      {icon}
    </Stack>
  );
};
